import { getProjects, deleteProject as deleteProjectApi } from '../services/api';
import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';
import { notifyDataChanged } from '../utils/dataEvents';
import type { CreatorInfo } from '../utils/permissions';
import { entityStoreMessages, removeItemsWhere } from './storeHelpers';
import { usePaymentStoreBase } from './paymentStore';

export interface Project extends CreatorInfo {
  id: string;
  userId: string; // 建立者（權限判斷用）
  name: string;
  customerId: string;
  description?: string;
  quoteId?: string | null;
  customer: {
    id: string;
    name: string;
    archived?: boolean;
  };
  quote?: {
    id: string;
    title: string;
  } | null;
  status: string;
  startDate?: string;
  endDate?: string;
}

const useProjectStoreBase = createEntityStore<Project>({
  entityName: 'project',
  fetchFn: getProjects,
  deleteFn: deleteProjectApi,
  toast,
  messages: entityStoreMessages,
});

export { useProjectStoreBase };

export const useProjectStore = () => {
  const store = useProjectStoreBase();

  // 刪除專案時後端連同底下的收款一起刪：收款列表同步移除，再通知資料異動
  const confirmDelete = async () => {
    const projectId = store.itemToDeleteId;
    await store.confirmDelete();
    removeItemsWhere<any>(usePaymentStoreBase, payment => (payment.projectId ?? payment.project?.id) === projectId);
    notifyDataChanged('projects');
  };

  return {
    projects: store.items,
    pagination: store.pagination,
    error: store.error,
    isPageLoading: store.isPageLoading,
    showDeleteConfirmModal: store.showDeleteConfirmModal,
    isDeleting: store.isDeleting,
    fetchProjects: store.fetchItems,
    setCurrentPage: store.setCurrentPage,
    handleDelete: store.handleDelete,
    confirmDelete,
    closeDeleteModal: store.closeDeleteModal,
    updateProject: store.updateItem,
    addProject: store.addItem,
    replaceProject: (tempId: string, realProject: Project) => store.updateItem(tempId, realProject),
    removeProject: (id: string) => removeItemsWhere<Project>(useProjectStoreBase, project => project.id === id),
  };
};
